var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4478 14.9694C13.7622 12.1403 16.1535 10 19 10V10C21.8465 10 24.2378 12.1403 24.5522 14.9694L24.804 17.2356C24.8072 17.2645 24.8088 17.279 24.8104 17.2933C24.9394 18.4169 25.3051 19.5005 25.8836 20.4725C25.8909 20.4849 25.8984 20.4973 25.9133 20.5222L26.4914 21.4856C27.0159 22.3599 27.2782 22.797 27.2216 23.1559C27.1839 23.3946 27.061 23.6117 26.8757 23.7668C26.5971 24 26.0873 24 25.0678 24H12.9322C11.9127 24 11.4029 24 11.1243 23.7668C10.939 23.6117 10.8161 23.3946 10.7784 23.1559C10.7218 22.797 10.9841 22.3599 11.5086 21.4856L12.0867 20.5222C12.1016 20.4973 12.1091 20.4849 12.1164 20.4725C12.6949 19.5005 13.0606 18.4169 13.1896 17.2933C13.1912 17.279 13.1928 17.2645 13.196 17.2356L13.4478 14.9694Z",
    stroke: "#00A898",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1022 24.4059C16.2731 25.1501 16.6498 25.8077 17.1737 26.2767C17.6976 26.7458 18.3396 27 19 27C19.6604 27 20.3024 26.7458 20.8263 26.2767C21.3502 25.8077 21.7269 25.1501 21.8978 24.4059",
    stroke: "#00A898",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.e0b2dddb9a287cdb16abdd4c3e666164.svg";
export { ForwardRef as ReactComponent };